import { i18n } from '@/plugins/i18n';

export interface TabAxisOptions {
    axisTitles: string[];
    enableChartType: boolean;
    fixedChartTypes: ('line'|'bar'|'area')[];
    enableGlobalScale: boolean;
}

const defaultTabOptions: TabAxisOptions = {
    axisTitles: [
        i18n.t('widget-wizard.tab.metrics.first-y-axis').toString(),
        i18n.t('widget-wizard.tab.metrics.second-y-axis').toString(),
    ],
    enableChartType: true,
    fixedChartTypes: [],
    enableGlobalScale: false,
};

export { defaultTabOptions };
